import { cn } from '@src/lib/utils';

import {
    DateAiChatCalendarButton,
    DateAiChatLabel,
    dateAiChatControlClass,
    dateAiChatFormClass,
    dateAiChatInputClass,
} from '../ProcessFieldDate/ProcessFieldDateAiChatAppearance';
import { useDateAiChatPlaceholder } from '../ProcessFieldDate/useDateAiChatPlaceholder';

import {
    ShadcnFormDateRangePickerFlow,
    type ShadcnFormDateRangePickerFlowProps,
} from '@shadcn-features/core/ShadcnForm/fields/ShadcnFormDateRangePickerFlow';

export function ProcessFieldDateRangePickerAiChat({
    label,
    className,
    fieldProps,
    format,
    placeholders,
    disabled,
    ...props
}: ShadcnFormDateRangePickerFlowProps) {
    const placeholder = useDateAiChatPlaceholder(
        format || undefined,
        props.picker,
    );
    return (
        <ShadcnFormDateRangePickerFlow
            {...props}
            disabled={disabled}
            format={format || undefined}
            placeholders={placeholders ?? [placeholder, placeholder]}
            label={label && <DateAiChatLabel>{label}</DateAiChatLabel>}
            className={cn(dateAiChatFormClass, className)}
            fieldProps={{
                ...fieldProps,
                completeOnly: true,
                sequentialSelection: true,
                className: cn(
                    dateAiChatControlClass,
                    'flex-row! gap-2! [&>div:first-child]:flex-none! [&>div:first-child]:w-auto! [&>div:first-child]:max-w-[45%]!',
                    fieldProps?.className,
                ),
                separator: (
                    <span className='shrink-0 text-(--color-neutral-6)'>-</span>
                ),
                startPickerProps: {
                    className: cn(dateAiChatInputClass, 'w-max! max-w-full'),
                    fitContent: true,
                    renderSuffix: () => null,
                },
                endPickerProps: {
                    className: dateAiChatInputClass,
                    renderSuffix: (open) => (
                        <DateAiChatCalendarButton
                            open={open}
                            disabled={disabled}
                        />
                    ),
                },
            }}
        />
    );
}
